module.exports = require("@pb/kit-component-element-group");